// extracted by mini-css-extract-plugin
export default {"modal":"xY7M5QMEMoQSUu210aLd","titleWrapper":"vHLgvpIhIMA22SEptkrt","table":"kHFHZPAg2z_ZhL9tVVer","detailsCell":"cFoYcUmqSS7j0QtEx7xL"};